var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInformatique(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 4)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.454 19.193V2.172C2.454.978 3.425 0 4.612 0h22.873c1.132 0 2.061.935 2.061 2.074v17.12H2.454zM32 20.213v1.22C32 22.844 30.851 24 29.45 24H2.436A2.451 2.451 0 010 21.548v-1.33c2.183-.005 31.024-.005 32-.005z",
    fill: "#0F1941",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.827 16.864V4.254c0-.986.803-1.793 1.782-1.793h18.866c.933 0 1.702.769 1.702 1.713v12.69H4.827zm13.316 5.891h-4.282a.651.651 0 010-1.3h4.287a.65.65 0 01.646.65.657.657 0 01-.65.65z",
    fill: "#F7F5F0",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFB511",
    d: "M18.549 14.16H13.86V9.441h4.688z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E74536",
    d: "M18.549 9.441H13.86V4.724h4.688zm4.687 4.719h-4.688V9.441h4.688z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFB511",
    d: "M23.236 9.441h-4.688V4.724h4.688z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6BA5B4",
    d: "M13.858 14.16H9.17V9.441h4.688z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#0F1941",
    transform: "rotate(-44.887 11.514 6.812)",
    cx: 11.514,
    cy: 6.812,
    r: 1.627
  }))));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAgNCkiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPHBhdGggZD0iTTIuNDU0IDE5LjE5M1YyLjE3MkMyLjQ1NC45NzggMy40MjUgMCA0LjYxMiAwaDIyLjg3M2MxLjEzMiAwIDIuMDYxLjkzNSAyLjA2MSAyLjA3NHYxNy4xMkgyLjQ1NHpNMzIgMjAuMjEzdjEuMjJDMzIgMjIuODQ0IDMwLjg1MSAyNCAyOS40NSAyNEgyLjQzNkEyLjQ1MSAyLjQ1MSAwIDAgMSAwIDIxLjU0OHYtMS4zM2MyLjE4My0uMDA1IDMxLjAyNC0uMDA1IDMyLS4wMDV6IiBmaWxsPSIjMEYxOTQxIiBmaWxsLXJ1bGU9Im5vbnplcm8iLz4KICAgICAgICA8cGF0aCBkPSJNNC44MjcgMTYuODY0VjQuMjU0YzAtLjk4Ni44MDMtMS43OTMgMS43ODItMS43OTNoMTguODY2Yy45MzMgMCAxLjcwMi43NjkgMS43MDIgMS43MTN2MTIuNjlINC44Mjd6TTE4LjE0MyAyMi43NTVoLTQuMjgyYS42NTEuNjUxIDAgMCAxIDAtMS4zaDQuMjg3Yy4zNTQgMCAuNjQ2LjI5Mi42NDYuNjVhLjY1Ny42NTcgMCAwIDEtLjY1LjY1eiIgZmlsbD0iI0Y3RjVGMCIgZmlsbC1ydWxlPSJub256ZXJvIi8+CiAgICAgICAgPHBhdGggZmlsbD0iI0ZGQjUxMSIgZD0iTTE4LjU0OSAxNC4xNkgxMy44NlY5LjQ0MWg0LjY4OHoiLz4KICAgICAgICA8cGF0aCBmaWxsPSIjRTc0NTM2IiBkPSJNMTguNTQ5IDkuNDQxSDEzLjg2VjQuNzI0aDQuNjg4ek0yMy4yMzYgMTQuMTZoLTQuNjg4VjkuNDQxaDQuNjg4eiIvPgogICAgICAgIDxwYXRoIGZpbGw9IiNGRkI1MTEiIGQ9Ik0yMy4yMzYgOS40NDFoLTQuNjg4VjQuNzI0aDQuNjg4eiIvPgogICAgICAgIDxwYXRoIGZpbGw9IiM2QkE1QjQiIGQ9Ik0xMy44NTggMTQuMTZIOS4xN1Y5LjQ0MWg0LjY4OHoiLz4KICAgICAgICA8Y2lyY2xlIGZpbGw9IiMwRjE5NDEiIHRyYW5zZm9ybT0icm90YXRlKC00NC44ODcgMTEuNTE0IDYuODEyKSIgY3g9IjExLjUxNCIgY3k9IjYuODEyIiByPSIxLjYyNyIvPgogICAgPC9nPgo8L3N2Zz4K";
export { SvgInformatique as ReactComponent };